import { EyeIcon, NewCommentIcon } from '@/src/assets/icons'
import { Pagination, Typography } from '@mui/material'
import { useRouter } from 'next/router'
import { Fragment, useState } from 'react'
import AnnouncementMultiLabels from './AnnouncementLabels'
import CommonApi from '@/pages/api'
import { useStore } from '@/src/types/store'
import { getAnnouncementProps } from '../announcements'
import { formatDate, getAnnouncementUrl } from '@/src/types/helper'
import Link from 'next/link'
interface AnnouncementContentProps {
  announcements: any
  currPage: number
  handlePageChange: (val: number) => void
  handleAnnouncement: (data: getAnnouncementProps) => void
}

const AnnouncementContent = ({
  announcements,
  handlePageChange,
  currPage,
  handleAnnouncement
}: AnnouncementContentProps) => {
  const { profile, annnoucementPage, homeTheme } = useStore()
  const isLoggedIn = profile?.user_type ? true : false
  const [page, setPage] = useState(currPage)

  const handleOnPageChange = (event: React.ChangeEvent<unknown>, newPage: number) => {
    handlePageChange(newPage)
    setPage(newPage)
  }

  const router = useRouter()

  const handleAction = async (mode: string, type: boolean, id: number) => {
    const likeData = {
      like: !type
    }
    const viewData = {
      view: !type
    }

    try {
      const response = await CommonApi({
        path: `like-view?id=${id}`,
        method: 'patch',
        data: mode === 'like' ? likeData : viewData
      })

      if (response.status) {
        handleAnnouncement({
          labels: '',
          years: [],
          page: annnoucementPage,
          searchKey: '',
          wantLoading: false
        })
      }
    } catch (error) {
      console.log('error', error)
    }
  }

  const stripHtml = (html: string) =>
    html
      ?.replace(/<[^>]*>/g, ' ')
      .replace(/\s+/g, ' ')
      .trim() || ''

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col rounded-2xl bg-white border border-[#0000000F] overflow-hidden">
        {Object.entries(announcements.results).map(([date, entries]: any) => (
        <Fragment key={date}>
          {entries?.map((announcement: any) => {
            return (
              <Link
                key={announcement.created_on}
                href={getAnnouncementUrl(announcement.headline, announcement?.id)}
                className="flex flex-col gap-1 sm:grid sm:grid-cols-[110px_minmax(0,1fr)_auto] sm:gap-6 sm:items-center px-4 sm:px-6 py-4 border-b border-[#0000000F] last:border-b-0 hover:bg-[#FAFAFC] transition-colors cursor-pointer"
              >
                <Typography
                  variant="caption"
                  color="text.secondary"
                  className="pt-1 whitespace-nowrap tracking-wide"
                >
                  {formatDate(announcement?.display_date, 'dateOnly')}
                </Typography>

                <div className="min-w-0 flex flex-col gap-1">
                  <div className="flex items-center gap-2 flex-wrap min-w-0">
                    <Typography
                      variant="subtitle1"
                      color="text.primary"
                      className="hover:text-primary-main transition-colors break-words"
                    >
                      {announcement?.headline || ''}
                    </Typography>
                    <AnnouncementMultiLabels data={announcement.labels} />
                  </div>

                  {announcement?.show_short_summary && announcement?.short_summary && homeTheme?.show_short_summaries && (
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      className="line-clamp-1 break-words"
                    >
                      {stripHtml(announcement.short_summary)}
                    </Typography>
                  )}
                </div>

                <div className="flex items-center gap-4 sm:gap-5 pt-1 whitespace-nowrap">
                  <div className="flex items-center gap-1.5">
                    <EyeIcon className="w-4 h-4 fill-[#0000008A]" />
                    <Typography variant="caption" color="text.secondary">
                      {announcement.view}
                    </Typography>
                  </div>
                  <div className="flex items-center gap-1.5">
                    <NewCommentIcon className="w-4 h-4 fill-[#0000008A]" />
                    <Typography variant="caption" color="text.secondary">
                      {announcement?.questions}
                    </Typography>
                  </div>
                </div>
              </Link>
            )
          })}
        </Fragment>
      ))}
      </div>
      <Pagination
        className="flex justify-end"
        count={Math.ceil(announcements.total / 10)}
        page={page}
        onChange={handleOnPageChange}
        sx={{
          '& .MuiPaginationItem-root': {
            '&.Mui-selected': {
              backgroundColor: '#07004D',
              color: 'white'
            }
          }
        }}
      />
    </div>
  )
}

export default AnnouncementContent
